import { ILocaleConfig } from "@/config/locale.config";
import { SupportedLocale, LocaleToLabelMap } from "@/enums/locale.enum";

// France-specific locale configuration
const franceLocaleConfig: ILocaleConfig = {
  supportedLocales: [
    SupportedLocale.FR,
    SupportedLocale.EN,
    SupportedLocale.RU,
  ],
  defaultLocale: SupportedLocale.FR,
  languageTabs: [
    {
      key: SupportedLocale.FR,
      label: LocaleToLabelMap.get(SupportedLocale.FR)!,
    },
    {
      key: SupportedLocale.EN,
      label: LocaleToLabelMap.get(SupportedLocale.EN)!,
    },
    {
      key: SupportedLocale.RU,
      label: LocaleToLabelMap.get(SupportedLocale.RU)!,
    },
  ],
};

export default franceLocaleConfig;
